module.exports = __webpack_public_path__ + "static/media/tagged_1.661fb981.png";